///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { CustomerDTO } from '../../../generated/shared-types.model';

export const accordionFeatureKey = 'accordion';

export interface AccordionState {
    isLoading: boolean;
    customersList: CustomerDTO[];
    selectedCustomerId: number;
    currentCustomer: CustomerDTO;
}

export const initialState: AccordionState = {
    isLoading: false,
    customersList: null,
    selectedCustomerId: null,
    currentCustomer: null
};
